
webpack.register(
    'components/timeline/timeline',
    function() {
        return import('components/timeline/timeline');
    },
    true
);